import { useRouter } from 'next/router'
import { useLayoutEffect } from 'react'

import { useSWRConfig } from 'swr'

import { api } from 'lib/api/api'

function Logout() {
  const { mutate } = useSWRConfig()
  const { query } = useRouter()

  useLayoutEffect(() => {
    Promise.allSettled([
      api.logout({
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      })
    ])
      .then(() =>
        mutate(
          () => true, // which cache keys are updated
          undefined, // update cache data to `undefined`
          { optimisticData: undefined, populateCache: false, revalidate: false } // do not revalidate
        )
      )
      .catch(() => {})
      .finally(() => {
        localStorage.clear()
        // When a user deletes their account, we set the
        // `feedback_event` and redirect from /logout to
        // /login so we know to display the cancellation
        // survey. Be sure to pass on the query parameter
        // to /login.
        const { feedback_event, redirect } = query
        const q = {
          ...(feedback_event && { feedback_event }),
          ...(redirect && { redirect })
        } as Record<string, string>
        const qs = new URLSearchParams(q).toString()
        window.location.href = `/login${qs ? '?' + qs : ''}`
      })
  }, [])

  return null
}

Logout._noLayout = true

export default Logout
